import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'components/button/index';
import { updateStartChannels, editStartChannel } from 'pages/administration.page';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';

export const StartChannelGroup = withTranslation()(
  class extends React.Component {
    state = {
      showEditForm: false,
    };

    toggleEdit = () => this.setState({ showEditForm: !this.state.showEditForm });

    onDelete = (e) => {
      e.preventDefault();

      this.props.updateState(updateStartChannels(this.props.startChannels, this.props.group.groupName, -1));
    };

    onEdit = (e) => {
      e.preventDefault();
      this.toggleEdit();

      const newGroupName = e.target.elements.namedItem('group-name').value;
      const newStartChannel = e.target.elements.namedItem('start-channel').value;

      if (this.props.group.groupName !== newGroupName || this.props.group.channel !== newStartChannel) {
        this.props.updateState(
          editStartChannel(this.props.startChannels, this.props.group.groupName, newGroupName, Number(newStartChannel))
        );
      }
    };

    render() {
      const { t } = this.props;
      return (
        <div className="policy-box">
          {!this.state.showEditForm && (
            <div className="row policy-header">
              <div className="col-6">
                <span>{this.props.group.groupName}</span>
              </div>
              <div className="col-6">
                <span>{this.props.group.channel}</span>
                <button type="button" className="link-button edit-icons">
                  <FontAwesomeIcon icon={faTrash} onClick={this.onDelete} />
                </button>
                <button type="button" className="link-button edit-icons">
                  <FontAwesomeIcon icon={faPencil} onClick={this.toggleEdit} />
                </button>
              </div>
            </div>
          )}
          {this.state.showEditForm && (
            <div className="policy-header">
              <div
                className={
                  this.state.showEditForm ? 'input-group input-group-sm mb-3' : 'input-group input-group-sm mb-3 d-none'
                }
              >
                <form className="row" onSubmit={this.onEdit} ref={this.formRef}>
                  <div className="col-xl-6 col-md-6 col-sm-6 col-6">
                    <input
                      type="text"
                      className="form-control edit-input"
                      placeholder={t('enter_group_organizational_unit')}
                      name="group-name"
                      required
                      defaultValue={this.props.group.groupName}
                    />
                  </div>
                  <div className="col-xl-2 col-md-2 col-sm-6 col-6">
                    <input
                      type="text"
                      className="form-control edit-input input-channel"
                      placeholder={t('enter_group_organizational_unit')}
                      name="start-channel"
                      defaultValue={this.props.group.channel}
                      required
                    />
                  </div>
                  <div className="input-group-append">
                    <button
                      type="button"
                      className="btn link-button btn-link"
                      onClick={this.toggleEdit}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('cancel')}
                    </button>
                    <Button type={'submit'}>{t('ok')}</Button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);
